// jednoduchý košík v localStorage
var KEY = "cart_v1";
var _listeners = [];

function load() {
    try {
        var txt = localStorage.getItem(KEY);
        if (!txt) { return { items: [] }; }
        var data = JSON.parse(txt);
        if (!data || !Array.isArray(data.items)) { return { items: [] }; }
        return data;
    } catch (e) {
        return { items: [] };
    }
}

function save(cart) {
    localStorage.setItem(KEY, JSON.stringify(cart));
    notify();
}

function notify() {
    for (var i = 0; i < _listeners.length; i++) {
        try { _listeners[i](getCart()); } catch (e) {}
    }
}

export function getCart() {
    return load();
}

export function subscribe(listener) {
    if (typeof listener !== "function") { return function () {}; }
    _listeners.push(listener);
    return function () {
        var idx = _listeners.indexOf(listener);
        if (idx >= 0) { _listeners.splice(idx, 1); }
    };
}

export function clearCart() {
    save({ items: [] });
}

export function addItem(product, qty) {
    if (!product) { return; }
    var q = parseInt(qty, 10);
    if (isNaN(q) || q <= 0) { q = 1; }

    // identifikácia podľa id, fallback na slug
    var id = product.id != null ? String(product.id) : (product.slug || "");
    if (!id) { return; }

    var cart = load();
    var items = cart.items;

    var i;
    var found = -1;
    for (i = 0; i < items.length; i++) {
        if (items[i].id === id) { found = i; break; }
    }

    if (found >= 0) {
        items[found].qty += q;
    } else {
        items.push({
            id: id,
            slug: product.slug || null,
            name: product.name || "",
            price: Number(product.price) || 0,
            imageUrl: product.imageUrl || null,
            qty: q
        });
    }
    save(cart);
}

export function setQty(id, qty) {
    var cart = load();
    var i;
    for (i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id === String(id)) {
            var n = parseInt(qty, 10);
            if (isNaN(n) || n <= 0) {
                cart.items.splice(i, 1); // 0 alebo zlé číslo = odstrániť
            } else {
                cart.items[i].qty = n;
            }
            break;
        }
    }
    save(cart);
}

export function removeItem(id) {
    var cart = load();
    cart.items = cart.items.filter(function (it) { return it.id !== String(id); });
    save(cart);
}

export function getCount() {
    var cart = load();
    var sum = 0;
    var i;
    for (i = 0; i < cart.items.length; i++) { sum += cart.items[i].qty; }
    return sum;
}

export function getTotal() {
    var cart = load();
    var sum = 0;
    var i;
    for (i = 0; i < cart.items.length; i++) {
        sum += (cart.items[i].price || 0) * (cart.items[i].qty || 0);
    }
    return sum;
}
